import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useMutation } from '@apollo/react-hooks';
import { UpdateGoogleAdsStatus, UpdateGoogleAdsStatusVariables } from './__generated__/UpdateGoogleAdsStatus';

const UPDATE_GOOGLE_ADS_STATUS_MUTATION = gql`
  mutation UpdateGoogleAdsStatus($googleAdIds: [ID!]!, $status: GoogleStatusEnum!) {
    updateGoogleAdsStatus(googleAdIds: $googleAdIds, status: $status) {
      googleAds {
        id
        status
      }
      errors
    }
  }
`;

export const useUpdateGoogleAdsStatus = () => {
  return useMutation<UpdateGoogleAdsStatus, UpdateGoogleAdsStatusVariables>(UPDATE_GOOGLE_ADS_STATUS_MUTATION, {
    client: kmsClient
  });
};
